<template>
    <section :aria-label="t('developmentJourneys.goalProgress.reflectButton')" class="mt-5 space-y-4 border-t border-border pt-5">
        <div class="flex items-start gap-3 rounded-lgr bg-surface p-4">
            <DevelopmentJourneyHourglass class="mt-1 size-[22px] shrink-0" />
            <p class="nadia-chat text-ink">{{ message }}</p>
        </div>
        <div class="flex flex-wrap items-center justify-between gap-3 border-t border-border pt-3">
            <BaseButton theme="tertiary" size="sm" @click="$emit('actions')">{{ t("developmentJourneys.goalProgress.actionsButton") }}</BaseButton>
            <BaseButton theme="tertiary" size="sm" class="inline-flex items-center gap-2 whitespace-nowrap" :disabled="busy" :aria-busy="busy" @click="$emit('reflect')">
                <LoadingSpinner v-if="busy" class="size-4 shrink-0" aria-hidden="true" />
                {{ busy ? t("developmentJourneys.goalProgress.reflectionStarting") : t("developmentJourneys.goalProgress.reflectButton") }}
            </BaseButton>
            <output :aria-label="t('developmentJourneys.goalProgress.reflectButton')" class="sr-only">{{
                busy ? t("developmentJourneys.goalProgress.reflectionStarting") : ""
            }}</output>
        </div>
    </section>
</template>

<script setup lang="ts">
import BaseButton from "~vue/components/BaseButton.vue";
import DevelopmentJourneyHourglass from "~vue/icons/DevelopmentJourneyHourglass.vue";
import LoadingSpinner from "~vue/icons/LoadingSpinner.vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();
defineProps<{ message: string; busy: boolean }>();
defineEmits<{ reflect: []; actions: [] }>();
</script>
